// settings routes — ungated beyond privateMiddleware (reachable by both roles).
export const settingsLoader = () => null;
